/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Slim_TaglineInputs */

const en_footer_slim_tagline = /** @type {(inputs: Footer_Slim_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One key · one wallet · every provider`)
};

const zh_hans1_footer_slim_tagline = /** @type {(inputs: Footer_Slim_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个密钥 · 一个钱包 · 所有服务商`)
};

const pt_br2_footer_slim_tagline = /** @type {(inputs: Footer_Slim_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma chave · uma carteira · todos os provedores`)
};

const es_footer_slim_tagline = /** @type {(inputs: Footer_Slim_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una clave · una billetera · todos los proveedores`)
};

const fr_footer_slim_tagline = /** @type {(inputs: Footer_Slim_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une clé · un portefeuille · tous les fournisseurs`)
};

const de_footer_slim_tagline = /** @type {(inputs: Footer_Slim_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Schlüssel · ein Guthabenkonto · jeder Anbieter`)
};

const ru_footer_slim_tagline = /** @type {(inputs: Footer_Slim_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Один ключ · один кошелёк · все поставщики`)
};

const it_footer_slim_tagline = /** @type {(inputs: Footer_Slim_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una chiave · un portafoglio · ogni provider`)
};

/**
* | output |
* | --- |
* | "One key · one wallet · every provider" |
*
* @param {Footer_Slim_TaglineInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_slim_tagline = /** @type {((inputs?: Footer_Slim_TaglineInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Slim_TaglineInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_slim_tagline(inputs)
	if (locale === "pt-BR") return pt_br2_footer_slim_tagline(inputs)
	if (locale === "es") return es_footer_slim_tagline(inputs)
	if (locale === "fr") return fr_footer_slim_tagline(inputs)
	if (locale === "de") return de_footer_slim_tagline(inputs)
	if (locale === "ru") return ru_footer_slim_tagline(inputs)
	if (locale === "it") return it_footer_slim_tagline(inputs)
	return en_footer_slim_tagline(inputs)
});